import React, { useState, useEffect, useRef } from 'react'
import { HeaderLink } from '../layout/Header'
import { inject } from 'mobx-react'
import { reaction } from 'mobx'
import * as constants from 'core/constants'
import { removeSessionToken } from '../../actions/Auth'
import PageLoader from '../common/PageLoader'
import { withRouter } from 'react-router-dom'
import useBeforeUnload from '../../hooks/useBeforeUnload'

const LoginForm = inject('store', 'actions')(({ store, actions, history }) => {
  const [loading, setLoading] = useState(false)
  const [pageLoading, setPageLoading] = useState(false)
  const timeoutRef = useRef(null)

  // Use the beforeUnload hook when pageLoading is true
  const { cleanup } = useBeforeUnload(pageLoading)

  useEffect(() => {
    // Set up socket event listener
    const disposer = reaction(
      () => store.socket,
      (socket) => {
        if (socket) {
          const subscription = socket.subscribe((event, data) => {
            switch(event) {
              case constants.COMPLETED_AGENT_LOGOUT: {
                console.warn('COMPLETED_AGENT_LOGOUT')
                subscription.unsubscribe()
                finalizeLogout()
                break
              }
            }
          })
        }
      }
    )

    // Cleanup on unmount
    return () => {
      disposer()
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  const finalizeLogout = async() => {
    setPageLoading(false)
    await cleanup()
    try {
      removeSessionToken()
      history.push('/login')
    } catch (error) {
      console.error('Error during finalize logout:', error)
    } finally {
      setPageLoading(false)
    }
  }
  
  const logout = async e => {
    e.preventDefault()
    if(loading) {
      return
    }
    setLoading(true)
    setPageLoading(true)

    try {
      if(store.agent && store.agent.extraConversationsActive) {
        actions.agent.cancelMoreConversations()
      }
      await actions.auth.logout()
      
      // Clear any existing timeout
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    } catch (error) {
      console.error('Error during logout:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <PageLoader 
        active={pageLoading} 
        content="Logging out..."
        size="large"
        inverted={true}
      />
      <HeaderLink onClick={logout} to="/logout" icon="sign-out" loading={loading} disabled={loading}>
        Logout
      </HeaderLink>
    </>
  )
})

export default withRouter(LoginForm)
